var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"y-btn y-btn_main y-fields__btn-main",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"y-btn__txt"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }